import type { ChatMessage } from '@/app/KeywordTracker/types/aiModalTypes';
import { useEffect, useRef } from 'react';
import ChatEmptyState from './ChatEmptyState';
import ChatMessageItem from './ChatMessageItem';

interface ChatItemsProps {
  messages: ChatMessage[];
  keyword?: string;
}

const ChatItems = ({ messages, keyword }: ChatItemsProps) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <div className="chat-content-scroll-area mt-3">
      {messages?.length > 0 ? (
        messages.map(message => (
          <ChatMessageItem key={message.id} message={message} />
        ))
      ) : (
        <ChatEmptyState keyword={keyword} />
      )}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default ChatItems;
